export const TRAFFIC_MONITORING_LIST = '交通量監視路線設定';
export const TRAFFIC_VOLUMNE_LIST = '交通量一覧';
export const LOCATION_LIST = '設置箇所一覧';